"use strict";

/**
 *  Gemeinsame Alu-Farbe der Terrassen-Konfiguratoren ( Holz , Alu ).
 *
 *  Legt der Kunde irgendwo eine Alu-Farbe fest ( Gestell , Wandrahmen ,
 *  Alu-Planken , Markisengestell , Alu-Rinne … ) , übernehmen alle Alu-
 *  Farbauswahlen , die er noch nicht selbst gewählt hat , diese Farbe – auch
 *  die gerade nicht sichtbaren. Wählt er danach z. B. eine Glasschiebewand ,
 *  ist deren Rahmen schon in der Farbe der Überdachung. Selbst gewählte
 *  Farben bleiben , und jede Auswahl lässt sich weiter ändern.
 *
 *  Die Auswahlen haben unterschiedliche Werte ( '7016' , '7016s' ,
 *  'anthracite' … ) , verglichen wird über die RAL-Nummer.
 *
 *  Nur echte Änderungen des Kunden ( change-Event der Auswahl ) zählen als
 *  Wahl. Programmatisch gesetzte Werte ( z. B. beim Laden eines Codes ) meldet
 *  der Konfigurator mit chosen().
 */
(function (root) {
  //  Werte ohne RAL-Nummer: Alu-Rinne
  var Named = {
    white: '9016',
    anthracite: '7016'
  };

  //  RAL-Nummer eines Werts ( '7016s' → '7016' , 'RAL 9005' → '9005' ) , sonst null
  var ral = function ral(value) {
    if (value === undefined || value === null) {
      return null;
    }
    var text = String(value).trim();
    if (Named[text]) {
      return Named[text];
    }
    var match = text.match(/\d{4}/);
    return match ? match[0] : null;
  };

  //  Option einer Auswahl zur RAL-Nummer ( die erste passende ) , sonst null
  var optionFor = function optionFor(select, code) {
    var options = select.querySelectorAll('option');
    for (var i = 0; i < options.length; i++) {
      if (ral(options[i].value) === code) {
        return options[i].value;
      }
    }
    return null;
  };

  /**
   *  apply( select , value ) setzt eine Auswahl ohne change-Event
   *  ( Konfigurator: Option wählen und Bonsai-Auswahl neu aufbauen ).
   */
  var create = function create(apply, scope) {
    var entries = [];
    var chosenSet = new Set();
    var _current = null;
    var entryFor = function entryFor(element) {
      for (var i = 0; i < entries.length; i++) {
        if (entries[i].select === element || entries[i].triggers.indexOf(element) !== -1) {
          return entries[i];
        }
      }
      return null;
    };

    //  Alle noch nicht gewählten Auswahlen auf die aktuelle Farbe setzen
    var spread = function spread(source) {
      if (_current === null) {
        return;
      }
      entries.forEach(function (entry) {
        if (entry === source || entry.lead || chosenSet.has(entry.select)) {
          return;
        }
        var value = optionFor(entry.select, _current);
        if (value !== null && entry.select.value !== value) {
          apply(entry.select, value);
        }
      });
    };
    var take = function take(entry) {
      var code = entry.read();
      if (code === null) {
        return;
      }
      _current = code;
      spread(entry);
    };

    //  Vor den Handlern der Konfiguratoren ( Capture ) , damit der nächste
    //  Request schon die übernommenen Farben enthält
    var listener = function listener(event) {
      var entry = entryFor(event.target);
      if (entry === null) {
        return;
      }
      chosenSet.add(entry.select);
      take(entry);
    };
    var target = scope || (typeof document !== 'undefined' ? document : null);
    if (target) {
      target.addEventListener('change', listener, true);
    }
    return {
      /**
       *  Alu-Farbauswahl anmelden.
       *  lead: Gestellfarbe der Alu-Überdachung , gibt die Farbe von Anfang
       *  an vor und wird selbst nie automatisch umgestellt.
       *  read: liest die RAL-Nummer ( Sonderfarbe als Freitext ) ,
       *  triggers: weitere Felder , deren Änderung die Auswahl betrifft.
       */
      add: function add(select, options) {
        if (!select) {
          return;
        }
        var settings = options || {};
        entries.push({
          select: select,
          lead: settings.lead === true,
          read: settings.read || function () {
            return ral(select.value);
          },
          triggers: (settings.triggers || []).filter(Boolean)
        });
      },
      //  Gilt als gewählt ( z. B. aus einem gespeicherten Code geladen )
      chosen: function chosen(select) {
        if (entryFor(select) !== null) {
          chosenSet.add(select);
        }
      },
      //  Farbe der Gestell-Auswahl übernehmen ( Start , nach dem Laden eines Codes )
      seed: function seed() {
        for (var i = 0; i < entries.length; i++) {
          if (entries[i].lead) {
            take(entries[i]);
            return;
          }
        }
      },
      current: function current() {
        return _current;
      },
      destroy: function destroy() {
        if (target) {
          target.removeEventListener('change', listener, true);
        }
      }
    };
  };

  //  Alu-Farbauswahlen der gemeinsamen Wand- und Sonnenschutz-Snippets
  var Wall_Selects = ['.sliding-glass-wall .frame-color select', '.sliding-wall .color-frame select', '.fixed-wall .color-frame select', '.alu-wall .wall-color select'];
  var Wall_Ids = ['left-wall', 'right-wall', 'front-wall', 'back-wall'];
  var Sun_Cover_Ids = ['frameColor', 'verticalAwningFrameColor'];
  var terraceSelects = function terraceSelects(doc) {
    var list = [];
    Wall_Ids.forEach(function (id) {
      var wall = doc.getElementById(id);
      if (wall) {
        Wall_Selects.forEach(function (selector) {
          var select = wall.querySelector(selector);
          if (select) {
            list.push(select);
          }
        });
      }
    });
    Sun_Cover_Ids.forEach(function (id) {
      var select = doc.getElementById(id);
      if (select) {
        list.push(select);
      }
    });
    return list;
  };
  var ConfiAluColors = {
    create: create,
    ral: ral,
    optionFor: optionFor,
    terraceSelects: terraceSelects
  };
  if (typeof module !== 'undefined' && module.exports) {
    module.exports = ConfiAluColors;
  }
  if (root) {
    root.ConfiAluColors = ConfiAluColors;
  }
})(typeof window !== 'undefined' ? window : null);